export const MUTATION_GROUP = 'numberFields' as const;
